export default __webpack_public_path__ + "static/media/thesis_req_2024.394a65ca.docx";